import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8aa54b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statusCard shadowed" }
const _hoisted_2 = { class: "headerRow" }
const _hoisted_3 = { class: "nameAndCreated" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "description pt-1" }
const _hoisted_6 = { class: "status" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statusLabel" }, "Current Status:", -1))
const _hoisted_8 = {
  style: {"width":"fit-content"},
  class: "statusName my-1 INFO"
}
const _hoisted_9 = {
  key: 0,
  class: "documentSection"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statusLabel pb-2" }, "Your documents are available to download:", -1))

import { notifyNetworkError } from '@/core/utils';
import { Citizen, Core } from "@minicity/core";
import { computed, } from 'vue';
import DocumentUploadWidget from '@/components/DocumentUploadWidget.vue';
import { getAttachmentViewLink } from './api';


export default /*#__PURE__*/_defineComponent({
  __name: 'KeyDocumentStatusCard',
  props: {
    keyDocumentType: null,
    keyDocument: null
  },
  setup(__props: any) {

const props = __props as {
  keyDocumentType: string,
  keyDocument: Citizen.KeyDocument,
}



const formattedType = computed(() => {
  switch (props.keyDocumentType) {
    case "BIRTH_RECORD": return "Birth Record";
    case "SOCIAL_SECURITY": return "Social Security";
    case "STATE_ID": return "State ID";
    case "VETERAN_ID": return "Veteran ID";
    case "GEORGIA_DFCS_BENEFITS": return "Georgia DFCS Benefits";
    default: return "Unknown";
  }
});

const formattedStatus = computed(() => {
  switch (props.keyDocument.status) {
    case 'REQUIRED': return "Preparing Application";
    case 'APPLIED': return "Applied";
    case 'OBTAINED': return "Approved";
    default: return "Unknown";
  }
});

const formattedDescription = computed(() => {
  switch (props.keyDocument.status) {
    case 'REQUIRED': return "Your caseworker is preparing to apply for your documents.";
    case 'APPLIED': return "Your application has been submitted, and we are waiting for the response.";
    case 'OBTAINED': return "Your application was successful - contact your caseworker to collect your documents.";
    default: return "Unknown";
  }
});

const downloadDocument = (doc: Core.Document) => {
  getAttachmentViewLink(doc)
    .then((attachmentViewLink: string) => window.open(attachmentViewLink))
    .catch(err => notifyNetworkError("Failed to download attachment", err));
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(formattedType)), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formattedDescription)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formattedStatus)), 1)
      ])
    ]),
    (__props.keyDocument.attachments.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(DocumentUploadWidget, {
            documents: __props.keyDocument?.attachments,
            onView: _cache[0] || (_cache[0] = ($event: any) => (downloadDocument($event))),
            readonly: ""
          }, null, 8, ["documents"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})